import styles from "./recommandation.module.css";


export default function Recommandation({quote, prices, image}){
    return(
        <div className={styles.item}>
            <img alt="Pressestimme" src={image}/>
            <p className="narrow-light">„{quote}“</p>
            <p dangerouslySetInnerHTML={{__html: prices}}/>
        </div>
    )
}